/* eslint-disable frontApplet/enforce-jsdoc */
import AppletError from './AppletError';
import { IBaseSosErrorParams } from './SosError';

export interface IAppletResourcesErrorParams extends IBaseSosErrorParams {
	kind: 'appletResourcesError';
}

export default class AppletResourcesError extends AppletError {
	public static readonly PATH_TO_DOCS: string = '/sdk/applet-basics';

	constructor(parameters: IAppletResourcesErrorParams) {
		super({
			...parameters,
			pathToDocs: AppletResourcesError.PATH_TO_DOCS,
			kind: 'appletError',
			type: parameters.type ? parameters.type : 'AppletResourcesError',
		});
	}
}
